module.exports = __webpack_public_path__ + "img/Wp_2069.91f636c2.png";